import { Navigate } from 'react-router-dom';

import { PermissionKeys } from '@client/api';
import { DashboardPaths } from '../../../pods/dashboard/dashboard.router';
import { AgreementsPaths } from '../../../pods/agreements/agreements.router';
import { useUserPermission } from '../../../hooks/useUserPermission';

export function AppIndexRoute() {
  const { hasAnyPermission, isLoading } = useUserPermission();

  if (isLoading) return null;

  const hasDashboardAccess = hasAnyPermission([PermissionKeys.User.DashboardView, PermissionKeys.Tenant.DashboardView]);

  return (
    <Navigate to={hasDashboardAccess ? DashboardPaths.Dashboard : AgreementsPaths.AgreementList} replace />
  );
}
